import { render, staticRenderFns } from "./ReportIncedent.vue?vue&type=template&id=74bdc6bc&scoped=true"
import script from "./ReportIncedent.vue?vue&type=script&lang=js"
export * from "./ReportIncedent.vue?vue&type=script&lang=js"
import style0 from "./ReportIncedent.vue?vue&type=style&index=0&id=74bdc6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bdc6bc",
  null
  
)

export default component.exports